import { render, staticRenderFns } from "./EntityMultiselect.vue?vue&type=template&id=1448430a&"
import script from "./EntityMultiselect.vue?vue&type=script&lang=js&"
export * from "./EntityMultiselect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports